import { Tooltip } from "@mui/material";

export default function IconsWithTooltip({ title, icon }) {
    return (
        <Tooltip title={title}>
            {icon}
        </Tooltip>
    );
}